import { NgModule } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { AssetListComponent } from "./asset-list.component";
import { NgxPaginationModule } from "ngx-pagination";
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from "ngx-bootstrap";

@NgModule({
    declarations: [
      AssetListComponent
    ],
    imports: [
      FormsModule,
      CommonModule,
      RouterModule,
      NgxPaginationModule,
      TooltipModule.forRoot(),
      ModalModule.forRoot()
    ]
})
export class AssetListModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/serviceObject/asset/list/asset-list.module.ts